// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-component-container{
    padding-top: 130px;
    min-height: 50vh;
}

.blog-list-container{
    display: flex;
    flex-direction: row;
    
}

.blog-list{
    width:60%;
}

.filters{
    width:20%;
    display: flex;
    flex-direction: column;
    margin:20px 100px;
    
}

.filters input{
    width:300px;
    height:40px;
    margin-bottom: 20px;
}

.filters select {
        width: 310px;
        height: 40px;
        margin-bottom: 20px;
}

.filters-mobile{
    display: none;
}

.pagination {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    gap: 10px;
}

.page-button {
    padding: 8px 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    width:100px;
}

.page-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.page-info {
    font-size: 14px;
    margin: auto 10px;
    position: relative;
    top: 0px;
    margin: 10px;
}

.no-blog-msg{
    display: flex;
    justify-content: center;
    align-items: center;

}

@media screen and (max-width:768px){
   .blog-component-container{
    padding-top: 180px;
   }
   .blog-list-container {
       display: flex;
       flex-direction: column;
       justify-content: center;
       align-items: center;

   }
   .filters{
    display: none;
   }
   .filters-mobile{
     display: flex;
     flex-direction: column;
     width:60%;
    
   }
   .filters-mobile input{
     padding: 5px;
   }
   .blog-list {
       width: 80%;
   }
   
}`, "",{"version":3,"sources":["webpack://./src/Styles/BlogList.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA;QACQ,YAAY;QACZ,YAAY;QACZ,mBAAmB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;GACG;IACC,kBAAkB;GACnB;GACA;OACI,aAAa;OACb,sBAAsB;OACtB,uBAAuB;OACvB,mBAAmB;;GAEvB;GACA;IACC,aAAa;GACd;GACA;KACE,aAAa;KACb,sBAAsB;KACtB,SAAS;;GAEX;GACA;KACE,YAAY;GACd;GACA;OACI,UAAU;GACd;;AAEH","sourcesContent":[".blog-component-container{\n    padding-top: 130px;\n    min-height: 50vh;\n}\n\n.blog-list-container{\n    display: flex;\n    flex-direction: row;\n    \n}\n\n.blog-list{\n    width:60%;\n}\n\n.filters{\n    width:20%;\n    display: flex;\n    flex-direction: column;\n    margin:20px 100px;\n    \n}\n\n.filters input{\n    width:300px;\n    height:40px;\n    margin-bottom: 20px;\n}\n\n.filters select {\n        width: 310px;\n        height: 40px;\n        margin-bottom: 20px;\n}\n\n.filters-mobile{\n    display: none;\n}\n\n.pagination {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    margin: 20px 0;\n    gap: 10px;\n}\n\n.page-button {\n    padding: 8px 16px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    width:100px;\n}\n\n.page-button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.page-info {\n    font-size: 14px;\n    margin: auto 10px;\n    position: relative;\n    top: 0px;\n    margin: 10px;\n}\n\n.no-blog-msg{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n@media screen and (max-width:768px){\n   .blog-component-container{\n    padding-top: 180px;\n   }\n   .blog-list-container {\n       display: flex;\n       flex-direction: column;\n       justify-content: center;\n       align-items: center;\n\n   }\n   .filters{\n    display: none;\n   }\n   .filters-mobile{\n     display: flex;\n     flex-direction: column;\n     width:60%;\n    \n   }\n   .filters-mobile input{\n     padding: 5px;\n   }\n   .blog-list {\n       width: 80%;\n   }\n   \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
